import * as React from "react";

const ThumbsUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.868}
    height={19.836}
    viewBox="0 0 20 20"  // Adding the viewBox attribute
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.99 7.33a1.881 1.881 0 0 1 1.878 1.878l-.008.008a1.887 1.887 0 0 1-.91 1.6 1.87 1.87 0 0 1-.083 2.713.463.463 0 0 1-.067.05 1.969 1.969 0 0 1-.476.292 1.845 1.845 0 0 1 .434 1.186 1.888 1.888 0 0 1-1.094 1.7 1.689 1.689 0 0 1-.977 2.7.38.38 0 0 1-.167.042H10.4a11.156 11.156 0 0 1-3.724-1.1v.175a1.251 1.251 0 0 1-1.252 1.252H1.252A1.251 1.251 0 0 1 0 18.584V8.566a1.251 1.251 0 0 1 1.252-1.252h4.175a1.251 1.251 0 0 1 1.252 1.252v.267c2.379-.877 4.767-3.891 4.767-7.673A1.167 1.167 0 0 1 12.54.017a2.153 2.153 0 0 1 2.288 1.762c.572 2.032-.149 3.784-.846 5.477l-.014.033-.017.042ZM5.427 19a.413.413 0 0 0 .417-.417V8.566a.413.413 0 0 0-.417-.417H1.252a.413.413 0 0 0-.417.417v10.018a.413.413 0 0 0 .417.416Zm11.2-8.741h.367v-.008a1.044 1.044 0 0 0 0-2.087h-3.661a.41.41 0 0 1-.342-.184.437.437 0 0 1-.042-.392l.25-.626c.651-1.578 1.319-3.206.827-4.968C13.775 1.1 13.133.76 12.657.835c-.092.017-.376.075-.376.317 0 4.3-2.847 7.689-5.6 8.549v7.781a11.769 11.769 0 0 0 3.719 1.186h4.934a.864.864 0 0 0 0-1.728h-.184a.417.417 0 1 1 0-.835h.31a.471.471 0 0 0 .058-.008h.367a1.044 1.044 0 0 0 0-2.087.417.417 0 0 1 0-.835h.735a1.044 1.044 0 1 0 0-2.087.417.417 0 0 1 0-.835Zm-12.87 7.374a.785.785 0 1 1 .785.785.784.784 0 0 1-.785-.785Zm.735 0c0 .025.05.05.05.05v-.1Z"
    />
  </svg>
);

export default ThumbsUpIcon;
